module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }